import React from "react";
import { greenBar, redBar, yellowBar } from "../../../helpers/constants";
import ProgressBar from "./ProgressBar";

const LEGEND = [
  { key: "Yes", color: greenBar, label: "Performed", short: "Yes" },
  {
    key: "Incomplete",
    color: yellowBar,
    label: "Incomplete",
    short: "Inc.",
  },
  { key: "No", color: redBar, label: "Not performed", short: "No" },
];

const DomainProgress = ({ graphData }) => {
  const counts = {
    Yes: Number(graphData?.Yes) || 0,
    Incomplete: Number(graphData?.Incomplete) || 0,
    No: Number(graphData?.No) || 0,
  };
  const max = Math.max(counts.Yes, counts.Incomplete, counts.No, 1);
  const barHeight = (value) => Math.max(8, Math.round((value / max) * 56));

  return (
    <aside className="progress-wrapper" aria-label="Practices summary">
      <div className="progress-title">Practices</div>
      <div className="progress-bar-container">
        {LEGEND.map((item) => (
          <div className="progress-col" key={item.key}>
            <span className="progress-count">{counts[item.key]}</span>
            <ProgressBar
              color={item.color}
              height={barHeight(counts[item.key])}
              width="16px"
            />
            <span className="progress-labels" title={item.label}>
              {item.short}
            </span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default DomainProgress;
